import { MouseEvent, useState } from 'react';
import { Popover as MuiPopover, popoverClasses, styled } from '@mui/material';
import { LwPopoverProps } from './popover.types';

export const LwPopover = ({
  children,
  id,
  triggerButton,
  anchorOrigin = { vertical: 'bottom', horizontal: 'left' },
  transformOrigin = { vertical: 'top', horizontal: 'left' },
}: LwPopoverProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const popoverId = open && id ? id : undefined;

  return (
    <>
      {triggerButton({
        onClick: handleClick,
      })}
      <StyledPopover
        id={popoverId}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        slotProps={{
          root: {
            sx: {
              backgroundColor: 'transparent',
            },
          },
        }}
      >
        {children}
      </StyledPopover>
    </>
  );
};

const StyledPopover = styled(MuiPopover)(({ theme }) => ({
  [`& .${popoverClasses.paper}`]: {
    padding: theme.spacing(5),
    borderRadius: theme.spacing(4),
  },
}));
